import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { navigationHistoryReducer } from '@shared/navigation-history/navigation-history.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('navigationHistory', navigationHistoryReducer),

  ]
})
export class NavigationHistoryModule { }
